import { Header } from "@bp/ui-components";
import { type ReactNode, useEffect } from "react";
import styles from "./Page.module.scss";

type PageProps = {
  /** Page title — rendered via the DS Header and set as the document title. */
  title: string;
  /** Optional lead/description paragraph shown under the title. */
  description?: ReactNode;
  /** Optional header actions (DS Header action buttons). */
  actions?: React.ComponentProps<typeof Header>["actions"];
  children: ReactNode;
};

/**
 * Shared page shell (modelled on planung-frontend's Page): renders the title
 * through the DS Header, sets the document title, and lays out the content.
 * Replaces the per-page raw `<h1 style={…}>` + bare max-width wrappers.
 */
export function Page({ title, description, actions, children }: PageProps) {
  useEffect(() => {
    const previous = document.title;
    document.title = `${title} · Schulsuite-Admin`;
    return () => {
      document.title = previous;
    };
  }, [title]);

  return (
    <div className={styles.page}>
      <Header className={styles.header} headline={title} size="l" actions={actions} />
      {description != null && <p className={styles.description}>{description}</p>}
      {children}
    </div>
  );
}
